// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"c2694026","332":"a5a6eff2"}[chunkId] + ".chunk.css";
};